// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3OwR0","loaderOuter":"PageOverlayLoader_loaderOuter__1qquO"};